
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.885 7.202c-2.6 3.3-5.2 6.5-7.7 9.8l-1.2 1.5c-.2-.1-.3-.3-.4-.4-1.3-1.7-3.1-3.1-4.6-4.6-.9-.9-1.3 2.1-.7 2.8l5.3 5.3c.2.2.5.3.7 0l9.3-11.7c.6-.7.1-3.7-.7-2.7z"}})])
          )
        }
      }
    